<template>
  <div ref="context">
    <slot/>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue"

const props = defineProps({
  selector: { type: String, default: "input, select, textarea" },
})

const context = ref()

onMounted(() => {
  const field = context.value.querySelector(props.selector)

  if (field?.focus) {
    field.focus()
  }

  if (field?.select) {
    field.select()
  }
})
</script>
